export const PRESET_NAME_CONTROL = 'grant-name-control';
export const PRESET_NAME_REQUIRED_ERROR = 'PRESET_NAME_REQUIRED_ERROR';
export const PRESET_NAME_REQUIRED_MESSAGE = 'Preset Name is required field';
